import { render } from "./SolucaoTecnicaView.vue?vue&type=template&id=6afbdc10"
import script from "./SolucaoTecnicaView.vue?vue&type=script&lang=js"
export * from "./SolucaoTecnicaView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__